import React, {Fragment, Component} from 'react';
import {withTranslation} from 'react-i18next';
import {fetchUserStatus} from '../actions';
import {Guide} from '../components/Config.cfa';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import { Accordion, Message, Icon } from 'semantic-ui-react';

class Settings extends Component {

    constructor() {
        super(...arguments);
        this.props.onLoad()
    }

    componentDidMount(){
      window.scrollTo(0, 0);
    }

    render() {

        const status = this.props.status;
        const days   = status.days || 0;
        const domain = status.domain || '';

        const port = status.port || 0;
        const password = status.password || '';
        const dimmer = Object.keys(this.props.status).length === 0;
        const leftDays = parseInt(status.leftDays || 0, 10);

        const autoConfig = {
            password,
            port,
            prefix:domain,
            leftDays:leftDays,
            code:this.props.status.code,
            hashed:this.props.status.hashed,
            user_id:this.props.status.configureId,
            user_vip:this.props.status.vip
        };

        return <>
          <Guide t={this.props.t} data={autoConfig}/>
        </>
  }
}

const mapStateToProps = (state) => {
    const main = state.console.main;
    return {status: main.status};
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLoad: () => {
            dispatch(fetchUserStatus());
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Settings));
